<div class="transformCustomer f-p">
  <div class="container-xl">
    <h1 data-aos="fade-down">Transform customer service</h1>
    <p class="f-m c-8080">Connect. Engage. Delight.</p>
    <div class="row align-items-centers">
      <!-- Stats Column -->
      <div class="col-12 text-block col-md-5">
        <div class="column transformCustomer--left">
          <div class="col">
            <span class="val" data-aos="fade-right">56%</span>
            <span class="text">Increase in call productivity</span>
          </div>
          <div class="col">
            <span class="val" data-aos="fade-right">73%</span>
            <span class="text">Increase in customer satisfaction</span>
          </div>
          <div class="col">
            <span class="val" data-aos="fade-right">94%</span>
            <span class="text"
              >Average <br />
              response rate</span
            >
          </div>
        </div>
      </div>
      <!-- Image Column -->
      <div class="col-12 col-md-7 text-center transformCustomer--right">
        <div class="image-container">
          <div class="image1">
            <img src="assets/images/objects-1.png" alt="" />
          </div>
          <div class="image2">
            <img src="assets/images/objects-2.png" alt="" />
          </div>
          <div class="image3">
            <img src="assets/images/objects-4.png" alt="" />
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
